<template>
  <div>
    <sys-select-base
        :model.sync="selected"
        :items="items"
        :loading="loading"
        :label="label"
        :error="error"
        :errors="errors"
        :clearable="clearable"
        :hint="hint"
        persistent-hint
    />
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'SysSelectIntegrationScheduleType',
  data: () => ({
    items: [],
    loading: false,
    selected: null
  }),
  created() {
    this.getItems();
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    errors: {
      type: Array,
    },
    label: {
      type: String,
      required: false
    },
    hint: {
      type: String,
      required: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    ids: {

    },
    model: {}
  },
  watch: {

    selected(val){
      this.$emit('update:model', val);
    },

    model(val){
      this.selected = val;
    },
  },
  methods: {
    ...mapActions('integration', ['ActionIndexIntegrationScheduleTypes']),
    async getItems() {
      this.loading = true

      let payload = {
        find_columns: {
            active: 1,
        }
      }

      if(this.ids){
        payload.find_columns.id = this.ids;
      }
      
      await this.ActionIndexIntegrationScheduleTypes(payload)
          .then((res) => {
            this.items = res.data;
            this.selected = this.model;
          })
          .finally(() => {
            this.loading = false;
          })
    }
  }
}
</script>